// extracted by mini-css-extract-plugin
export default {"container":"Ls-z","heading":"Ms-z","text":"Ns-z","info":"Os-z","link":"Ps-z","fullMaxWidth":"Qs-z"};